import React from 'react';

import './Warranty.scss';
import FontAwesomeIcon from '../Icon';

const Warranty = ({ duration }) => (
  <div className="warranty">
    <div className="warranty__icon">
      <FontAwesomeIcon
        weight="solid"
        glyph="shield-check"
      />
    </div>
    <div className="warranty__duration">
      {duration === "0" ? "NA" : duration+" yr"}
    </div>
  </div>
);

export default Warranty;
